import { createMuiTheme } from "@material-ui/core/styles";
const primaryColors = {
  dark: "#00338d",
  second: "#00338d",
  main: "#0073cf",
  ligth: "#FB313E",
  lighter: "#FC767F"
};

const secondaryColors = {
  dark: "#878A00",
  main: "#FBFF12",
  ligth: "#FCFF4F",
  lighter: "#FDFF8A",
  transparent: "#DDDDDD"
};

export const theme = createMuiTheme({
  palette: {
    primary: primaryColors,
    secondary: secondaryColors
  },
  typography: {
    fontFamily: "'Trebuchet', 'Muli', sans-serif"
  },
  breakpoints: {
    // Define custom breakpoint values.
    // These will apply to Material-UI components that use responsive
    // breakpoints, such as `Grid` and `Hidden`. You can also use the
    // theme breakpoint functions `up`, `down`, and `between` to create
    // media queries for these breakpoints
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1800
    }
  }
});

export default theme;
